import config from "config";
import axios from "axios";

type ResponseType = {
  message: string;
  data: {
    meta: {
      prev: null;
      next: number;
      count: number;
      limit: number;
      pages: number[];
      current_page: number;
    };
    agg: any;
    result: {
      name: string;
      canonical_name: string;
    }[];
  }[];
};

const getRegionsBulk = async (params = {}) => {
  try {
    const { data }: { data: ResponseType } = await axios.get(
      `${config.API_URL}/api/v1/regions/index_bulk`,
      { params: { ...params, use_java_api: true } },
    );
    return { data };
  } catch ({ response }: any) {
    const res: any = response;
    return { error: res?.data?.message?.user_friendly_message };
  }
};

export default getRegionsBulk;
